import { call, put, select, take, fork } from 'redux-saga/effects'

import { fetchApi } from '../helpers/fetchApi'

import Logger from '../../helpers/Logger'

import {
  fetchProductCareSuccess,
  fetchProductCareFailure
} from '../../actionCreators/productCare/productCareActioCreators'

import { FETCH_PRODUCT_CARE_REQUEST } from '../../actionTypes/productCareActionTypes'

const logger = Logger.getInstance()

const endpoint = '/product-api/pdp-service/partNumber'
const apiVersion = 'application/vnd.argos-product.v2+json'

const getRequiredProductData = (productApiResponse, productStore) => {
  const pricePayload = productApiResponse.included.find(item => item.type === 'prices')
  const price = pricePayload && pricePayload.attributes.now
  const title = productApiResponse.data.attributes.name

  const index = productStore.productCare.warranties.findIndex(
    care => care.sku === productApiResponse.data.attributes.partNumber
  )
  const warranties = [...productStore.productCare.warranties]
  warranties[index] = { ...productStore.productCare.warranties[index], price, title }
  return {
    productCare: {
      warranties
    }
  }
}

const product = state => state.productStore

function* productCareSaga(action, baseUrl) {
  const { productCareSku } = action.payload
  const start = Date.now()

  try {
    const { data: productData = {} } = yield select(product)
    const url = `${baseUrl || ''}${endpoint}/${productCareSku}`
    const headers = { Accept: apiVersion }
    const jsonData = yield call(fetchApi, url, null, headers)
    const responseTime = Date.now() - start
    logger.debug('warrantyLogger', { action, responseTime, jsonData }, 'warrantyAction read')
    const successAction = fetchProductCareSuccess(getRequiredProductData(jsonData, productData))
    yield put(successAction)
  } catch (error) {
    const response = {
      errorDetail: error.toString(),
      errorCode: error.status || 500,
      data: {
        productId: productCareSku
      }
    }
    if (error.response && error.response.body && error.response.body.errors) {
      response.errorDetail = error.response.body.errors
    }
    logger.error(
      'apiLogger',
      { arguments: [error.status, error.message, error.productId], error },
      `productCareSaga ${error.status || 500} Error`
    )

    const failureAction = fetchProductCareFailure(response)
    yield put(failureAction)
  }
}

// Watches for the 'FETCH_PRODUCT_CARE_REQUEST' action then fires the saga
function* watchProductCare() {
  while (true) {
    const { payload, baseUrl } = yield take(FETCH_PRODUCT_CARE_REQUEST)

    yield fork(productCareSaga, { payload }, baseUrl)
  }
}

export { productCareSaga, endpoint, product, watchProductCare }
